import React, { Component } from "react";
import { connect } from "react-redux";
import LoginForm from "../components/Form";
import { login } from "redux/authenticate/actions";

class Form extends Component {
  onSubmit = data => {
    const { login } = this.props;
    login(data);
  };

  render() {
    return <LoginForm errors={this.props.errors} onSubmit={this.onSubmit} />;
  }
}

const mapStateToProps = ({ user: { errors } }) => ({
  initialValues: null,
  errors
});

export default connect(mapStateToProps, { login })(Form);
